
import vClickOutside from 'v-click-outside'
import analytics from '@/helpers/analytics'
import sha256 from 'simple-sha256'

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  data () {
    return {
      submitted: false,
      form: {
        email: null,
        name: null,
        source: 'newsletter',
        dunhill: false
      }
    }
  },
  computed: {
    site () {
      return this.$store.state.site
    },
    siteType () {
      return this.$store.state.siteType
    },
    icon () {
      return `/images/icons/${this.site}.png`
    },
    showDunhillCheck () {
      return false

      /*
      const { country } = this.$store.state
      return country.toUpperCase() === 'US'
      */
    }
  },
  mounted () {
    this.initializeGoogleSignInWithRetry()
  },
  methods: {
    // Initialize Google Sign-In with retry mechanism
    initializeGoogleSignInWithRetry (attempt = 1, maxAttempts = 3) {
      if (attempt > maxAttempts) {
        console.warn('=== Google Sign-In initialization failed after maximum attempts')
        this.hideGoogleSignInButton()
        return
      }

      // Check if Google Identity Services is available
      if (typeof window.google === 'undefined' || !window.google.accounts || !window.google.accounts.id) {
        console.warn(`Google Identity Services not available - attempt ${attempt}/${maxAttempts}`)
        // Retry after a delay
        setTimeout(() => {
          this.initializeGoogleSignInWithRetry(attempt + 1, maxAttempts)
        }, 1000 * attempt) // Exponential backoff
        return
      }

      this.initializeGoogleSignIn()
    },

    // Initialize Google Sign-In
    initializeGoogleSignIn () {
      // Check if Google Identity Services is available
      if (typeof window.google === 'undefined' || !window.google.accounts || !window.google.accounts.id) {
        console.warn('=== Google Identity Services not available')
        this.hideGoogleSignInButton()
        return
      }

      try {
        window.google.accounts.id.initialize({
          client_id: this.$config.GOOGLE_AUTH_CLIENT_ID,
          callback: this.handleCredentialResponse
        })

        const buttonElement = document.getElementById('btnGoogleSignIn')
        if (!buttonElement) {
          console.warn('=== Google Sign-In button element not found')
          return
        }

        window.google.accounts.id.renderButton(buttonElement, {
          type: 'standard',
          size: 'large',
          shape: 'pill',
          text: 'signup_with',
          logo_alignment: 'left',
          click_listener: this.onClickHandler,
          width: 336
        })
      } catch (error) {
        console.error('Error initializing Google Sign-In:', error)
        this.hideGoogleSignInButton()
      }
    },

    hideGoogleSignInButton () {
      const buttonElement = document.getElementById('btnGoogleSignIn')
      if (buttonElement) {
        buttonElement.style.display = 'none'
      }
    },

    onClickHandler () {
      console.log('LC Sign up with Google button clicked...')
    },

    // Handle the credential response
    handleCredentialResponse (response) {
      const credential = response.credential
      const decodedCredential = this.parseJwt(credential)

      this.form.email = decodedCredential.email
      this.form.name = decodedCredential.name
      this.form.source = 'googleBtn'
      this.submit()
    },

    // Parse JWT token
    parseJwt (token) {
      const base64Url = token.split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))

      return JSON.parse(jsonPayload)
    },

    blurNewsletterInput () {
      analytics.track('newsletter-email-fill', this)
    },
    close () {
      this.$store.commit('setNewsletterModal', false)

      this.triggerCloseEvent()

      if (
        window.popUnder ||
        this.$store.state.device.isMobile ||
        this.$store.state.device.isTablet ||
        this.$store.state.browser.name === 'safari') { return }

      // Try temporary disable of popunder
      // createPopUnder()
    },
    triggerCloseEvent () {
      // Trigger event if form was not submitted
      if (!this.submitted) {
        analytics.track('newsletter-closed-empty', this)
      }
    },
    async submit () {
      const entryId = this.$store.state.entryId
      this.submitted = true
      try {
        const payload = {
          emailaddress: this.form.email,
          name: this.form.name,
          source: this.form.source,
          dunhill: this.form.dunhill
        }

        analytics.track('newsletter-submit', this, payload)

        await this.$axios.$post(`newsletter/subscribe/${entryId}`, payload)
        this.$store.commit('user/set', this.form)
        this.close()
      } catch (e) {
        return this.$toast.error('An error has ocurred, please reload and try again', { position: 'top-center', duration: 4000 })
      }

      this.$store.commit('user/set', this.form)
      this.close()

      const emailSha256 = await sha256(this.form.email)

      try {
        window.adara('identity', {
          email: emailSha256
        })
      } catch (e) {
        console.error(e)
        console.info('Error firing Adara event')
      }
    }
  }
}
